module.exports = __webpack_public_path__ + "assets/img/btn-detail-a547f727.png";